export const logger = {
  log: (message) => {
    console.log(message);
  },
  error: (message) => {
    console.error(message);
  },
};
